import axios from 'axios';
import CryptoJS from 'crypto-js';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'spe-default-key-2025';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Resolve tenant ID from /api/tenant/info (based on domain)
// and set X-Tenant-ID header dynamically
let tenantIdResolved = false;

export async function initTenant() {
  if (tenantIdResolved) return;
  try {
    const res = await axios.get(`${API_URL}/tenant/info`);
    if (res.data?.id) {
      apiClient.defaults.headers['X-Tenant-ID'] = res.data.id;
      tenantIdResolved = true;
    }
  } catch {
    // Fallback: no tenant header sent
  }
}

// Set tenant ID directly (called from App.js after tenant/info fetch)
export function setTenantId(id) {
  if (id) {
    apiClient.defaults.headers['X-Tenant-ID'] = id;
    tenantIdResolved = true;
  }
}

// AES-256-CBC encryption matching backend openssl_decrypt
export function encryptPayload(data) {
  const jsonStr = JSON.stringify(data);
  const key = CryptoJS.SHA256(ENCRYPTION_KEY);
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(jsonStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // Combine IV + ciphertext, then base64
  const combined = iv.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}

export const campaignService = {
  getCampaign: (uuid) => apiClient.get(`/campaigns/${uuid}`),
  registerCustomer: (uuid, data) => apiClient.post(`/campaigns/${uuid}/register`, data),
  getVoucher: (code) => apiClient.get(`/vouchers/${code}`),
  checkVoucher: (code) => apiClient.get(`/vouchers/check?code=${code}`),
  updateCustomerProfile: (data) => apiClient.post('/customer/profile', {
    encrypted_payload: encryptPayload(data),
  }),
};

export default apiClient;
